import { DefaultRecordingTemplates } from "@/common/enums/enums";

// The specialty asked on the welcome, from the sign-up occupation when there
// is one, and the built-in templates suggested for it (the first is the
// default). Occupation names are the API's (occupations table).

export type Specialty =
  | "general"
  | "medical"
  | "surgical"
  | "nursing"
  | "allied";
export const SPECIALTIES: readonly Specialty[] = [
  "general",
  "medical",
  "surgical",
  "nursing",
  "allied",
];

const BY_OCCUPATION: Record<string, Specialty> = {
  "family physicians": "general",
  "medical specialist": "medical",
  "surgical specialist": "surgical",
  "nurse practitioner": "nursing",
  "paramedical practitioners": "allied",
};

export const specialtyFromOccupation = (
  occupation: string | null | undefined,
): Specialty | null =>
  BY_OCCUPATION[(occupation ?? "").trim().toLowerCase()] ?? null;

// The occupation saved for a specialty (Settings uses the same names).
export const occupationForSpecialty = (specialty: Specialty): string =>
  Object.entries(BY_OCCUPATION).find(([, value]) => value === specialty)?.[0] ??
  "family physicians";

const { SOAP, SPECIALIST, VOICE_TO_TEXT } = DefaultRecordingTemplates;
const SUGGESTIONS: Record<Specialty, readonly DefaultRecordingTemplates[]> = {
  general: [SOAP, VOICE_TO_TEXT, SPECIALIST],
  medical: [SPECIALIST, SOAP, VOICE_TO_TEXT],
  surgical: [SPECIALIST, SOAP, VOICE_TO_TEXT],
  nursing: [SOAP, VOICE_TO_TEXT, SPECIALIST],
  allied: [SOAP, VOICE_TO_TEXT, SPECIALIST],
};

export const suggestedTemplates = (
  specialty: Specialty | null,
): readonly DefaultRecordingTemplates[] => SUGGESTIONS[specialty ?? "general"];
